import { useEffect, useState } from "react";
import SyIcon from "../../../../shared/components/sy-icon";
import Login from "../../components/login-component";
import { useMutation } from "@tanstack/react-query";
import authService from "../../services/auth-service";
import { setCookie } from "../../../../utils/cookie";
import Register from "../../components/register-component";
import Password from "../../components/password-component";
import OneTimePassword from "../../components/one-time-password-component";
import { authConfig } from "../../auth-config";
import {
  getTempUserData,
  setTempUserData,
} from "../../../../feature/auth-slice/auth-slice";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { removeLocalData } from "../../../../utils/localstorage";
import { OrbToast } from "../../../../utils/orb-toast";
import { useTranslation } from "react-i18next";
import { authProps } from "../../auth-interface";

const AuthLayoutPopup = (props: authProps) => {
  const { onClose,view } = props;
  // const { companyId } = useParams();
  const { encryptData } = useParams();

  const [selectedDetails, setSelectedDetails] = useState<any>(authConfig[view]);
  const [verifyMail, setVerifyMail] = useState<any>(null);
  const dispatch = useDispatch();
  const tempData = useSelector(getTempUserData);
  const { t } = useTranslation();


  const handleCloseClick = () => {
    onClose("cancel");
  };

  const onSave = (value: any, type: any) => {
    if (type === authConfig.register.id) {
      register(value);
    } else if (type === authConfig.login.id) {
      login(value);
    } else if (type === authConfig.verify_email.id) {
      forgotPassword(value);
    } else if (type === authConfig.register_otp.id) {
      verify(value, type);
    } else if (type === authConfig.password_otp.id) {
      verify(value, type);
    } else {
      value.usr_email = verifyMail;
      resetPassword(value);
    }
  };

  const verify = (otp: any, type: any) => {
    if (type === authConfig.register_otp.id) {
      const payload = {
        email: tempData.userData.usr_email,
        otp: otp,
        userData: tempData.userData,
        companyData: tempData.companyData,
        orbitData: tempData.orbitData,
      };
      registerOtp(payload);
    } else {
      const payload = {
        email: verifyMail,
        otp: otp,
      };
      emailVerifyOtp(payload);
    }
  };

  const reSendOtp = () => {
  
    if(selectedDetails.id === authConfig.register_otp.id){
       reSendRegisterOtp()
    }else{
      resendEmailVerifyOtp()
    }
  };

  const reSendRegisterOtp =()=>{
    const payload = {
      ...tempData.userData,
      orb_status: tempData?.orbitData?.orb_status,
      cy_status: tempData?.companyData?.cmp_status,
      cy_name: tempData?.companyData?.cmp_name,
    };
    register(payload);
  }

  const resendEmailVerifyOtp =()=>{
    const payload ={
      usr_email:verifyMail
    }
    forgotPassword(payload)
  }

  //---register-related-api---//

  const { mutate: register, isPending: registerLoading } = useMutation({
    mutationFn: authService.register,
    onSuccess(data) {
      dispatch(setTempUserData(data.data.tempUserData));
     
      setSelectedDetails(authConfig.register_otp);
    },
  });

  const { mutate: registerOtp, isPending: registerOtpLoading } = useMutation({
    mutationFn: authService.registerOtp,
    onSuccess(data) {
      if (data.data.status === "success") {
        setCookie("auth_token", data.data.access_token);
        onClose("save");
      }
    },
  });

  //---login-related-api---//

  const { mutate: login, isPending: loginLoading } = useMutation({
    mutationFn: authService.login,
    onSuccess(data) {
      removeLocalData("volenteer");
      setCookie("auth_token", data.data.access_token);
      onClose("save");
    },
    onError(error:any) {
      OrbToast(t(error?.response?.data.message),'top-right','short','error')
    },
  });

  const { mutate: forgotPassword ,isPending:forgotPasswordLoading } = useMutation({
    mutationFn: authService.forgotPassword,
    onSuccess(data, variables, context) {
      setVerifyMail(data.data.email);
      setSelectedDetails(authConfig.password_otp);
    },
  });

  const { mutate: emailVerifyOtp ,isPending:emailVerifyOtpLoading} = useMutation({
    mutationFn: authService.emailVerifyOtp,
    onSuccess(data) {
      if(data.data.status === 'pending'){
        setSelectedDetails(authConfig.password);
      }else{
        OrbToast(t(data.data.message),'top-right','short','error')
      }
    },
  });

  const { mutate: resetPassword } = useMutation({
    mutationFn: authService.resetPassword,
    onSuccess(data, variables, context) {
      setSelectedDetails(authConfig.login);
    },
  });

  useEffect(() => {
    if (encryptData) {
      setSelectedDetails(authConfig.register);
    }
  }, [encryptData]);



  

  return (
    <>
      <div className={` d-flex align-items-center `}>
        <div className={`rounded-4  p-3 w-100   pop-bg`}>
          <div className="d-flex align-items-center justify-content-between pb-3">
            <h2 className="mohave m-0 title-font">{t(selectedDetails.header)}</h2>
            <SyIcon
              name="close"
              iconType="symbols"
              iconStyle="outlined"
              iconColor="white"
              className={` pointer`}
              onClick={handleCloseClick}
            />
          </div>

          <div className={`pe-1`}>
            {selectedDetails.id === authConfig.login.id && (
              <div className={'slide_in_left'}>
                <Login
                  setSelectedDetails={setSelectedDetails}
                  loginLoading={loginLoading}
                  save={onSave}
                />
              </div>
            )}
            {selectedDetails.id === authConfig.register.id && (
              <div className={'slide_in_right'}>
                <Register
                  setSelectedDetails={setSelectedDetails}
                  registerLoading={registerLoading}
                  save={onSave}
                />
              </div>
            )}
            {(selectedDetails.id === authConfig.verify_email.id ||
              selectedDetails.id === authConfig.password.id) && (
              <div className={'slide_in_right'}>
                <Password
                  selectedDetails={selectedDetails}
                  setSelectedDetails={setSelectedDetails}
                  save={onSave}
                  passwordLoading ={forgotPasswordLoading}
                />
              </div>
            )}
            {(selectedDetails.id === authConfig.password_otp.id ||
              selectedDetails.id === authConfig.register_otp.id) && (
              <div className={'slide_in_right'}>
                <OneTimePassword
                  selectedDetails={selectedDetails}
                  save={onSave}
                  reSendOtp={reSendOtp}
                  resendOtpLoading={forgotPasswordLoading || registerLoading}
                  otpLoading={registerOtpLoading || emailVerifyOtpLoading }
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AuthLayoutPopup;
